import Vue from "vue";
import Vuex from "vuex";
import Service from "../../../../service/api-hr.js";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {
        item:[],
    },

    mutations: {
        item(state, obj) {
            state.item = obj;
        },
    },

    actions: {
        status({commit}, data) {
            Service.idpReport('status', data, {})
                .then((response) => {
                    store.commit("idpReport/item", response.data.data)
                }).catch((err) => {
            });
        },
    },

    getters: {
        item(state, obj) {
            return state.item;
        },

    },
};

export default ServerModule;
